import { lightModeColors } from './themeConfig';

// Utility functions for light mode styling
export const getLightModeColor = (colorPath: keyof typeof lightModeColors) => {
  return lightModeColors[colorPath];
};

// Helper function to get nested color values
export const getNestedLightModeColor = (
  category: keyof typeof lightModeColors,
  subCategory: string
) => {
  const categoryColors = lightModeColors[category] as Record<string, string>;
  return categoryColors[subCategory];
};

// Common light mode styling patterns
export const lightModeStyles = {
  // Card styling
  card: {
    backgroundColor: lightModeColors.surface.card,
    border: `1px solid ${lightModeColors.borders.light}`,
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.04)',
  },

  // Table styling
  table: {
    backgroundColor: lightModeColors.surface.table,
    border: `1px solid ${lightModeColors.borders.light}`,
    borderRadius: '8px',
  },

  // Header styling
  header: {
    backgroundColor: lightModeColors.surface.header,
    borderBottom: `1px solid ${lightModeColors.borders.light}`,
  },

  // Sidebar styling
  sidebar: {
    backgroundColor: lightModeColors.surface.sidebar,
    borderRight: `1px solid ${lightModeColors.borders.medium}`,
  },

  // Input styling
  input: {
    backgroundColor: lightModeColors.background.elevated,
    border: `1px solid ${lightModeColors.borders.light}`,
    '&:focus': {
      borderColor: lightModeColors.borders.dark,
      boxShadow: `0 0 0 2px ${lightModeColors.borders.light}40`,
    },
  },

  // Button styling
  button: {
    primary: {
      backgroundColor: '#d97706', // Amber 600
      color: '#ffffff',
      '&:hover': {
        backgroundColor: '#b45309', // Amber 700
      },
    },
    secondary: {
      backgroundColor: lightModeColors.surface.card,
      color: lightModeColors.text.primary,
      border: `1px solid ${lightModeColors.borders.medium}`,
      '&:hover': {
        backgroundColor: lightModeColors.background.tertiary,
      },
    },
  },

  // Text styling
  text: {
    primary: {
      color: lightModeColors.text.primary,
    },
    secondary: {
      color: lightModeColors.text.secondary,
    },
    disabled: {
      color: lightModeColors.text.disabled,
    },
  },
};

// Export the colors for direct use
export { lightModeColors };
